import { Pipe, PipeTransform } from '@angular/core';
import { TriggerType } from '~core/models/payment.models';

@Pipe({
  name: 'triggerType',
  pure: true,
  standalone: true
})
export class PaymentTriggerTypePipe implements PipeTransform {
  private readonly triggerTypeMap: Record<TriggerType, string> = {
    automatic: 'Automatique',
    manual: 'Manuelle'
  };

  transform(method: TriggerType): string {
    return this.triggerTypeMap[method];
  }
}
